module.exports = __webpack_public_path__ + "static/img/zs-06.6e5c4ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zs-06.png
// module id = oR6G
// module chunks = 16